<script>
import RexModalInput from '@/rex-components/rex-modal-input.vue';
import { mapState } from 'vuex';

export default {
  components: {
    RexModalInput,
  },
  emits: ['onSearch'],
  props: {
    placeholder: {
      type: String,
      required: true,
    },
    searchValue: {
      type: String,
    },
  },
  computed: {
    ...mapState('logState/logCommonState', ['isADType']),
  },
  methods: {
    onSearch(str) {
      this.$emit('onSearch', str);
    },
  },
};
</script>

<template>
  <div class="source-search-box">
    <div class="source-search-icon">
      <BaseIcon
        name="search"
        iconColor="rgb(112, 112, 112)"
        height="0.813rem"
        width="0.813rem"
      />
    </div>
    <RexModalInput
      :placeholder="placeholder"
      :modelValue="searchValue"
      type="text"
      @update:modelValue="onSearch"
      size=""
      inputStyle="width: 100%;"
      id="log-nav-bar-search-input"
    />
  </div>
</template>

<style lang="scss" scoped>
.source-search-box {
  @include flex-center-vert;
  width: 100%;
  border: 0.063rem solid $border-grey;
  border-radius: 0.25rem;
}
.source-search-icon {
  transform: rotate(90deg);
  padding: 0rem 0.813rem;
}
:deep(.input-group) {
  background-color: $bg-secondary !important;
  border: none;
}
:deep(input) {
  background-color: $bg-secondary !important;
  padding-left: 0rem;
}
</style>
